// 파워 커브 캐시 저장소. 웹의 "조합 분석"과 PiP가 같은 팀 상세를 동시에 그려도 서버에는 (캐릭터, 무기)당 한 번만 요청한다.
// 컴포넌트 밖(모듈 단위)에 두어 두 화면과 여러 번의 팀 선택이 같은 캐시를 본다. 새로고침 전까지 유지하며 별도 만료는 없다.

export const powerCurveKey = (characterName, weaponName) => `${characterName}|${weaponName}`;

// fetchCurve(characterName, weaponName) → Promise<points[]>
export function createPowerCurveStore(fetchCurve) {
  let snapshot = {}; // { [key]: { status: 'loading' | 'done' | 'error', points } } — 바뀔 때마다 새 객체로 교체한다
  const listeners = new Set();

  const update = (key, entry) => {
    snapshot = { ...snapshot, [key]: entry };
    listeners.forEach((listener) => listener());
  };

  const request = (characterName, weaponName) => {
    if (!characterName || !weaponName) {
      return;
    }
    const key = powerCurveKey(characterName, weaponName);
    const current = snapshot[key];
    // 요청 중이거나 이미 불러온 조합은 다시 요청하지 않는다(실패한 조합만 재시도).
    if (current && current.status !== 'error') {
      return;
    }
    update(key, { status: 'loading', points: [] });
    fetchCurve(characterName, weaponName)
      .then((points) => update(key, { status: 'done', points }))
      .catch(() => update(key, { status: 'error', points: [] }));
  };

  return {
    request,
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
